import { useContext } from 'react'
import { useModal } from 'hooks'

import { ToastContext } from 'contexts'
import { useDeleteApiKeyByIdService } from 'services/apiKey/useDeleteApiKeyByIdService'

import { useApiKeysService } from 'services'
import columnConfig from './columnConfig'

const useApiKeys = () => {
    const { openModal, closeModal } = useModal()
    const { setToast } = useContext(ToastContext)

    const { data: apiKeys, refetch: apiKeyRefetch, loading: api_keys_loading } = useApiKeysService()
    const { deleteApiKeyById } = useDeleteApiKeyByIdService()

    const filteredApiKeys = apiKeys?.filter((key: { subnet_id: string }) => !key.subnet_id)

    const handleDeleteApiKey = async (id: string) => {
        openModal({
            name: 'delete-confirmation-modal',
            data: {
                deleteItem: async () => {
                    try {
                        await deleteApiKeyById(id)
                        await apiKeyRefetch()
                        closeModal('delete-confirmation-modal')
                        setToast({
                            message: 'API Key was deleted!',
                            type: 'positive',
                            open: true,
                        })
                    } catch (e) {
                        setToast({
                            message: 'Failed to delete API Key!',
                            type: 'negative',
                            open: true,
                        })
                        closeModal('delete-confirmation-modal')
                    }
                },
                label: 'Delete API Key?',
            },
        })
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const handleEditApiKey = (data: any) => {
        openModal({ name: 'edit-api-key-modal', data: data })
    }

    const config = columnConfig({ handleEditApiKey, handleDeleteApiKey })

    return {
        apiKeys: filteredApiKeys,
        handleDeleteApiKey,
        api_keys_loading: api_keys_loading && apiKeys?.length === 0,
        config,
    }
}

export default useApiKeys
